// @/lib/paymentUtils.js
import { getGuestToken, removeGuestToken } from "@/lib/auth";
import { setBearerToken } from "@/redux/slices/authSlice";

export const handlePaymentRedirect = ({
  isLogin,
  orderId,
  router,
  dispatch,
  toast,
}) => {
  if (!isLogin) {
    const token = getGuestToken();
    if (token) {
      router.push(`/success-order/${orderId}?token=${token}`);
      removeGuestToken();
      dispatch(setBearerToken({ guestToken: null, isLogin: false }));
    } else {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Guest token not found.",
      });
      router.push("/");
    }
  } else {
    router.push(`/success-order/${orderId}`);
  }
};